import { render, staticRenderFns } from "./carwash.vue?vue&type=template&id=6d9066ba&"
import script from "./carwash.vue?vue&type=script&lang=js&"
export * from "./carwash.vue?vue&type=script&lang=js&"
import style0 from "./carwash.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports